import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../services/api';
import ProductCard from '../components/ProductCard';
import './BestProducts.css';

function BestProducts() {
	const [products, setProducts] = useState([]);
	const [loading, setLoading] = useState(true);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const [totalCount, setTotalCount] = useState(0);

	useEffect(() => {
		fetchBestProducts(currentPage);
	}, [currentPage]);

	const fetchBestProducts = async (page = 1) => {
		try {
			setLoading(true);
			const response = await fetch(
				`${API_BASE_URL}/products/products/best/?page=${page}`
			);
			const data = await response.json();
			
			setProducts(data.results || []);
			setTotalCount(data.count || 0);
			setTotalPages(data.total_pages || 0);
		} catch (error) {
			console.error('인기상품 로딩 실패:', error);
			setProducts([]);
		} finally {
			setLoading(false);
		}
	};

	const handlePageChange = (pageNumber) => {
		setCurrentPage(pageNumber);
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	const renderPagination = () => {
		if (totalPages <= 1) return null;

		return (
			<div className="pagination">
				<button
					onClick={() => handlePageChange(1)}
					disabled={currentPage === 1}
					className="page-btn"
				>
					처음
				</button>
				<button
					onClick={() => handlePageChange(currentPage - 1)}
					disabled={currentPage === 1}
					className="page-btn"
				>
					이전
				</button>

				{[...Array(totalPages)].map((_, index) => {
					const pageNumber = index + 1;
					if (
						pageNumber === 1 ||
						pageNumber === totalPages ||
						(pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
					) {
						return (
							<button
								key={pageNumber}
								onClick={() => handlePageChange(pageNumber)}
								className={currentPage === pageNumber ? 'page-btn active' : 'page-btn'}
							>
								{pageNumber}
							</button>
						);
					} else if (
						pageNumber === currentPage - 3 ||
						pageNumber === currentPage + 3
					) {
						return <span key={pageNumber}>...</span>;
					}
					return null;
				})}

				<button
					onClick={() => handlePageChange(currentPage + 1)}
					disabled={currentPage === totalPages}
					className="page-btn"
				>
					다음
				</button>
				<button
					onClick={() => handlePageChange(totalPages)}
					disabled={currentPage === totalPages}
					className="page-btn"
				>
					마지막
				</button>
			</div>
		);
	};

	if (loading) {
		return (
			<div className="best-products">
				<div className="best-header">
					<h1>🔥 인기상품</h1>
					<p>지금 가장 핫한 아이템만 모았어요!</p>
				</div>
				<div className="products-grid">
					{[...Array(8)].map((_, index) => (
						<div key={index} className="skeleton-card">
							<div className="skeleton-image"></div>
							<div className="skeleton-info">
								<div className="skeleton-title"></div>
								<div className="skeleton-price"></div>
							</div>
						</div>
					))}
				</div>
			</div>
		);
	}

	return (
		<div className="best-products">
			<div className="best-header">
				<h1>🔥 인기상품</h1>
				<p>지금 가장 핫한 아이템만 모았어요!</p>
			</div>

			{products.length === 0 ? (
				<div className="no-products">
					<div className="no-products-icon">📦</div>
					<p>인기상품이 없습니다.</p>
				</div>
			) : (
				<>
					<div className="products-grid">
						{products.map(product => (
							<ProductCard key={product.id} product={product} />
						))}
					</div>
					{renderPagination()}
				</>
			)}
		</div>
	);
}

export default BestProducts;